/* AAVO Launch Sale — countdown + welcome modal logic.
   Reads end timestamp from <html data-ls-end="...">.
   Hides everything gracefully when the sale ends. */
(function () {
  var DISMISS_KEY = 'aavo-launch-modal-dismissed';

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function getEnd() {
    var iso = document.documentElement.getAttribute('data-ls-end');
    if (!iso) return 0;
    var ts = Date.parse(iso);
    return isNaN(ts) ? 0 : ts;
  }

  function tick() {
    var end = getEnd();
    if (!end) return;
    var remaining = Math.max(0, end - Date.now());

    if (remaining === 0) {
      document.querySelectorAll('.ls-billboard, .ls-modal-backdrop, .ls-reopen')
        .forEach(function (el) { el.classList.add('ls-ended'); });
      return;
    }

    var days = Math.floor(remaining / 86400000);
    var hours = Math.floor((remaining % 86400000) / 3600000);
    var mins = Math.floor((remaining % 3600000) / 60000);
    var secs = Math.floor((remaining % 60000) / 1000);

    document.querySelectorAll('[data-ls-countdown]').forEach(function (el) {
      var part = el.getAttribute('data-ls-countdown');
      if (part === 'days') el.textContent = pad(days);
      else if (part === 'hours') el.textContent = pad(hours);
      else if (part === 'mins') el.textContent = pad(mins);
      else if (part === 'secs') el.textContent = pad(secs);
      else if (part === 'compact') el.textContent = days + 'd ' + pad(hours) + 'h ' + pad(mins) + 'm ' + pad(secs) + 's';
    });
  }

  function initModal() {
    var modal = document.querySelector('.ls-modal-backdrop');
    var reopen = document.querySelector('.ls-reopen');
    if (!modal) return;

    // Escape any transformed ancestor that would trap position:fixed.
    // (Aavo theme has transforms on parent sections, which collapse fixed -> absolute.)
    if (modal.parentElement !== document.body) document.body.appendChild(modal);
    if (reopen && reopen.parentElement !== document.body) document.body.appendChild(reopen);

    var dismissed = false;
    try { dismissed = sessionStorage.getItem(DISMISS_KEY) === '1'; } catch (e) {}

    function open() {
      modal.classList.add('is-open');
      if (reopen) reopen.classList.remove('is-visible');
    }
    function close() {
      modal.classList.remove('is-open');
      try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch (e) {}
      if (reopen) reopen.classList.add('is-visible');
    }

    if (!dismissed) {
      // Slight delay so the page's first paint lands before the modal punch
      setTimeout(open, 350);
    } else if (reopen) {
      reopen.classList.add('is-visible');
    }

    modal.addEventListener('click', function (e) {
      if (e.target === modal) close();
    });
    modal.querySelectorAll('[data-ls-modal-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); close(); });
    });
    if (reopen) {
      reopen.addEventListener('click', function (e) { e.preventDefault(); open(); });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
  }

  // —— Product page price decoration ————————————————————————
  function getDiscount() {
    var d = parseInt(document.documentElement.getAttribute('data-ls-discount') || '30', 10);
    return isNaN(d) ? 30 : d;
  }

  function formatMoney(cents, currencySymbol) {
    var dollars = (cents / 100).toFixed(2);
    return currencySymbol + dollars;
  }

  function parseMoneyText(s) {
    // Returns { symbol, amount_cents } or null. Handles "$49.95", "€49,95", etc.
    var m = s.match(/^([^\d]*)(\d+(?:[.,]\d{1,2})?)(.*)$/);
    if (!m) return null;
    var num = m[2].replace(',', '.');
    return { symbol: m[1] || '$', cents: Math.round(parseFloat(num) * 100), suffix: m[3] || '' };
  }

  function decoratePriceEl(moneyEl, discount) {
    if (!moneyEl || moneyEl.dataset.lsDecorated === '1') return;
    var raw = moneyEl.textContent.trim();
    var parsed = parseMoneyText(raw);
    if (!parsed) return;
    var newCents = Math.round(parsed.cents * (100 - discount) / 100);
    var newPrice = formatMoney(newCents, parsed.symbol) + parsed.suffix;

    moneyEl.dataset.lsDecorated = '1';
    var line = document.createElement('span');
    line.className = 'ls-price-line';

    var nowEl = document.createElement('span');
    nowEl.className = 'ls-price-now';
    nowEl.textContent = newPrice;

    var wasEl = document.createElement('s');
    wasEl.className = 'ls-price-was';
    wasEl.textContent = raw;

    var tagEl = document.createElement('span');
    tagEl.className = 'ls-price-tag';
    tagEl.textContent = '−' + discount + '% Launch';

    line.appendChild(nowEl);
    line.appendChild(wasEl);
    line.appendChild(tagEl);

    moneyEl.textContent = '';
    moneyEl.appendChild(line);
  }

  function decorateAllPrices() {
    var discount = getDiscount();
    document.querySelectorAll('.sls-price > .money, .sls-price > span.money, .sls-price-container .money')
      .forEach(function (el) { decoratePriceEl(el, discount); });
  }

  function stripCartButtonPrice() {
    // The cart button is rendered by Alpine.js with three spans:
    //   <span x-text="addToCartText">Add to Cart</span>
    //   <span x-show="currentVariantAvailable">&nbsp;–&nbsp;</span>
    //   <span x-show="currentVariantAvailable" x-html="formatMoney(currentPrice)">$49.95</span>
    // We hide the dash + price spans so the button reads just "Add to Cart".
    document.querySelectorAll('.add-to-cart-btn').forEach(function (btn) {
      var spans = btn.querySelectorAll('.push-btn__surface > span');
      // Hide the dash separator and the price (everything after the addToCartText span)
      var sawText = false;
      spans.forEach(function (s) {
        if (!sawText && s.hasAttribute('x-text')) { sawText = true; return; }
        if (sawText) s.style.display = 'none';
      });
    });
  }

  function initProductPage() {
    // 1. Try immediately, then poll for ~10s — covers Seal Subscriptions
    //    widgets that render after our DOMContentLoaded.
    var attempts = 0;
    function poll() {
      decorateAllPrices();
      stripCartButtonPrice();
      attempts++;
      if (attempts < 20) setTimeout(poll, 500);
    }
    poll();

    // 2. Long-lived observer — Seal re-renders prices when user changes
    //    plan selection. Re-decorate whenever new .money spans appear.
    //    The data-lsDecorated guard prevents double-processing.
    var rerunPending = false;
    var obs = new MutationObserver(function () {
      if (rerunPending) return;
      rerunPending = true;
      requestAnimationFrame(function () {
        rerunPending = false;
        decorateAllPrices();
        stripCartButtonPrice();
      });
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    tick();
    setInterval(tick, 1000);
    initModal();
    initProductPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
